import { render } from "./InteractiveProductItem.vue?vue&type=template&id=0905d2d8&scoped=true&ts=true"
import script from "./InteractiveProductItem.vue?vue&type=script&lang=ts"
export * from "./InteractiveProductItem.vue?vue&type=script&lang=ts"

import "./InteractiveProductItem.vue?vue&type=style&index=0&id=0905d2d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0905d2d8"]])

export default __exports__